'use client';

import React from 'react';
import { Partners } from '@/features/client/Partners/Partners';
import { Section } from '@/components/client/Section/Section';
import { Container } from '@/components/client/Container/Container';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';

const PartnersPage = () => {
  return (
    <div>
      {' '}
      <MainSectionLayout variant="primary" layout="sline">
        <MainSection label="Our Partners" title="Our Partners" description="" />
      </MainSectionLayout>
      <Section styles={{ paddingTop: 20 }} variant="secondary">
        <Container>
          <Partners />
        </Container>
      </Section>
      <Section>
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default PartnersPage;
